import React from 'react';
import StyledFooter from './footer.styles';

const Footer = () => {
  return <StyledFooter> Copyright © Naaman Curtis 2020 </StyledFooter>;
};

export default Footer;
